var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Home } from "./pages/home/home";
import { Login } from "./pages/auth/login";
import { RedirectPage } from "./shared/auth/redirect.page";
import { PageNotFound } from "./pages/notfound/notfound";
import { Header } from "./shared/header/header";
import { CartWidget } from "./shared/cart/cart";
import { RaffleTickets } from "./pages/raffle/raffle";
import { Register } from "./pages/auth/register";
import { useEffect, useState } from "react";
import { Deposit } from "./pages/deposit/deposit";
import { Account } from "./pages/account/account";
import { Notifications } from "./pages/notifications/notifications";
import { DrawDetail } from "./pages/raffle/draw";
import { MobileFooter } from "./shared/footer/mobile.footer";
import { isMobile } from "./App";
import { AdultWarningText, Footer } from "./shared/footer/footer";
import { Agreement } from "./pages/agreement/agreement";
import { UserMenu } from "./shared/auth/user.menu";
import { Withdraw } from "./pages/withdraw/withdraw";
import { Support } from "./pages/support/support";
import { AboutUs } from "./pages/aboutus/aboutus";
import { AccountTransactions } from "./pages/account/account.transactions";
import { Products } from "./pages/products/products";
import { Campaigns } from "./pages/campaign/campaign";
import { LiveStream } from "./pages/liveStream/liveStream";
import { HomeSlider } from "./pages/home/slider";
import { Games } from "./pages/games/games";
import { env, listGamePages, siteSettings } from "./constants/global.constants";
import Advertisement from "./shared/advertisement/advertisement";
import { Landing } from "./pages/auth/landing";
import { api } from "./services/http.service";
import DOMPurify from "dompurify";
import QrCard from "./pages/qr-card/qr-card";
import logo106 from "./assets/images/106D_1.png";
import { auth } from "./store/auth.store";
import ReportLine from "./pages/reportLine/report.line";
import { CookieSettings } from "./pages/account/account.cookie.settings";
import { GiftTicket } from "./pages/giftTicket/gift.ticket";
import { Helmet } from "react-helmet";
import { underServiceSubject } from "./store/misc.store";
import { slugify, useForceUpdate } from "./services/misc.functions";
import ssl from "./assets/images/ssl.png";
import paths from "./paths";
import { ScratchCards } from "./pages/games/scratch/scratch.cards";
import dealer_logo_4nala from "./assets/images/dealer-logos/4nala.png";
import dealer_logo_bilyoner from "./assets/images/dealer-logos/bilyoner.png";
import dealer_logo_fenerium from "./assets/images/dealer-logos/fenerium.png";
import dealer_logo_hepsiburada from "./assets/images/dealer-logos/hepsiburada.png";
import dealer_logo_migros from "./assets/images/dealer-logos/migros.png";
import dealer_logo_misli from "./assets/images/dealer-logos/misli.png";
import dealer_logo_nesine from "./assets/images/dealer-logos/nesine.png";
import dealer_logo_oley from "./assets/images/dealer-logos/oley.png";
import dealer_logo_passo from "./assets/images/dealer-logos/passo.png";
import dealer_logo_pazarama from "./assets/images/dealer-logos/pazarama.png";
import dealer_logo_pttavm from "./assets/images/dealer-logos/pttavm.png";
import dealer_logo_trendyol from "./assets/images/dealer-logos/trendyol.png";
import dealer_logo_tuttur from "./assets/images/dealer-logos/tuttur.png";
import { PaparaCoupons } from "./pages/paparaCoupons/papara.coupons";
import Game from "./pages/games/game/game";
import { Storage } from "./services/localstorege.service";
import { CartDropdown } from "./shared/cart/cart.dropdown";
var dealers = [
    { logo: dealer_logo_4nala, label: "4nala.com", link: "https://4nala.com/esya-piyangosu" },
    { logo: dealer_logo_bilyoner, label: "Bilyoner", link: "https://www.bilyoner.com/sans-oyunlari" },
    { logo: dealer_logo_fenerium, label: "Fenerium", link: "https://fenerium.com/%C5%9Fans-feneri" },
    { logo: dealer_logo_hepsiburada, label: "Hepsiburada", link: "https://www.hepsiburada.com/oynadikca-kazan" },
    { logo: dealer_logo_migros, label: "Migros", link: "https://www.migros.com.tr/" },
    { logo: dealer_logo_misli, label: "Misli", link: "https://www.misli.com/sans-oyunlari" },
    { logo: dealer_logo_nesine, label: "Nesine", link: "https://www.nesine.com/sans-oyunlari" },
    { logo: dealer_logo_oley, label: "Oley", link: "https://oley.com/esya-piyangosu" },
    { logo: dealer_logo_passo, label: "Passo", link: "https://www.passo.com.tr/tr" },
    { logo: dealer_logo_pazarama, label: "Pazarama", link: "https://www.pazarama.com/supercekilis" },
    { logo: dealer_logo_pttavm, label: "PTTAVM", link: "https://www.pttavm.com/surpriz-cekilis" },
    { logo: dealer_logo_trendyol, label: "Trendyol", link: "https://www.trendyol.com/sansli-cekilis" },
    { logo: dealer_logo_tuttur, label: "Tuttur", link: "https://www.tuttur.com/esya-piyangosu" },
];
var metaTags = {};
Object.entries(paths).forEach(function (_a) {
    var key = _a[0], value = _a[1];
    metaTags[value.url] = value;
});
var PageChangeHandler = function () {
    try {
        var pathname_1 = useLocation().pathname;
        var parentPath_1 = String(pathname_1);
        var canonicalLink = "".concat(env.web_link).concat(pathname_1);
        var gameList = Storage.get("games");
        var gameFixedLink = void 0;
        useEffect(function () {
            try {
                // @ts-ignore
                var metaTag = metaTags["/" + parentPath_1.split("/")[1]];
                console.log(metaTag.title);
                document.title = metaTag.title;
                // console.log(document.title);
                // @ts-ignore
                document.getElementsByTagName("meta").description.content = metaTag.description;
                // @ts-ignore
                document.getElementsByTagName("meta").keywords.content = metaTag.keywords;
            }
            catch (e) {
                console.log(e);
            }
            var id_homeHeader = document.getElementById("id_homeHeader");
            if (id_homeHeader && (parentPath_1 === paths.home.url || parentPath_1 === "" || parentPath_1 === "/")) {
                id_homeHeader.style.display = "flex";
            }
            else if (id_homeHeader) {
                id_homeHeader.style.display = "none";
            }
            // try {
            //     // @ts-ignore
            //     // let metaTag: any = MetaTags.find(
            //     //     (x: any) => x.path == parentPath.split("/")[1]
            //     // );
            //     if (!metaTag) {
            //         // @ts-ignore
            //         metaTag = metaTags.find((x: any) => x.path === paths.home.url);
            //     }
            //     document.title = metaTag.title;
            //     // @ts-ignore
            //     document.getElementsByTagName("meta").description.content =
            //         metaTag.description;
            //     // @ts-ignore
            //     document.getElementsByTagName("meta").keywords.content = metaTag.keywords;
            // } catch (e) {
            // }
            window.scrollTo(0, 0);
            var mainWrapper = document.getElementById("mainWrapper");
            // if (listCartHiddenPages.includes(pathname)) {
            //   if (mainWrapper) {
            //     mainWrapper.style.background = "unset";
            //   }
            // } else {
            //   if (mainWrapper) {
            //     mainWrapper.style.background = "var(--ps-body-bg)";
            //   }
            // }
            // Oyunlar sayfasında yan barı kaldırır, genişliği arttırır listGamePages globali içerisine yeni oyunların da pathleri eklenmeli
            var cartwidget = document.getElementById("cartwidget");
            var footerSection = document.getElementById("footerSection");
            if (listGamePages.includes(pathname_1)) {
                cartwidget.style.display = "none";
                if (isMobile) {
                    mainWrapper.className = "main-wrapper col-lg-12";
                }
                else {
                    mainWrapper.className = "main-wrapper col-lg-12";
                }
                footerSection.style.display = "none";
            }
            else {
                if ([paths.games.url, paths.newGames.url, paths.upcomingGames.url].includes(pathname_1)) {
                    mainWrapper.className = "main-wrapper col-lg-12";
                }
                else {
                    mainWrapper.className = "main-wrapper col-lg-9";
                }
                cartwidget.style.display = "contents";
                footerSection.style.display = "block";
            }
        }, [parentPath_1, pathname_1]);
        if ([paths.games.url, paths.newGames.url, paths.upcomingGames.url].includes(pathname_1)) {
            canonicalLink = "".concat(env.web_link).concat(paths.games.url);
        }
        if ([paths.scratch.url, paths.scratchMyCards.url, paths.scartchRules.url].includes(pathname_1)) {
            canonicalLink = "".concat(env.web_link).concat(paths.scratch.url);
        }
        if ([paths.raffleTickets.url].includes(pathname_1)) {
            canonicalLink = "".concat(env.web_link).concat(paths.raffleTickets.url);
        }
        if (gameList) {
            if (gameList
                .map(function (element) {
                return ("/" +
                    slugify(element.name
                        .toLowerCase()
                        .replaceAll("ü", "u")
                        .replaceAll("ş", "s")
                        .replaceAll("ç", "c")
                        .replaceAll("ğ", "g")
                        .replaceAll("ı", "i")
                        .replaceAll("ö", "o")));
            })
                .includes(pathname_1) &&
                !pathname_1.includes(paths.scratch.url)) {
                window.location.href = "".concat(env.web_link).concat(paths.games.url).concat(pathname_1);
            }
        }
        return (_jsx(_Fragment, { children: _jsxs(Helmet, { children: [_jsx("meta", { charSet: "utf-8" }), _jsx("title", { children: metaTags["/" + parentPath_1.split("/")[1]]["title"] }), _jsx("link", { rel: "canonical", href: "".concat(canonicalLink) })] }) }));
    }
    catch (e) {
        return _jsx(_Fragment, {});
    }
};
export function HomePromoSlider() {
    var _this = this;
    var _a;
    var _b = useState(null), homePromoHtml = _b[0], setHomePromoHtml = _b[1];
    var sanitizedData = function () { return ({
        __html: DOMPurify.sanitize(homePromoHtml.content),
    }); };
    useEffect(function () {
        api
            .start("post", env.accounting_api + "/misc/api/list-flatpages/", { slug: "home-slider" }, false)
            .then(function (res) {
            if (res.status) {
                setHomePromoHtml(res.data);
            }
        });
    }, []);
    var _c = useState(false), isLive = _c[0], setIsLive = _c[1];
    var _d = useState(null), broadcastUrl = _d[0], setBroadcastUrl = _d[1];
    var fetchLiveBroadcast = function () { return __awaiter(_this, void 0, void 0, function () {
        var res, broadcasts, now, _i, broadcasts_1, item, broadcastDate, endWindow, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, api.start("post", env.accounting_api + "/misc/api/list-broadcast/", {}, true)];
                case 1:
                    res = _a.sent();
                    broadcasts = Array.isArray(res === null || res === void 0 ? void 0 : res.data) ? res.data : [];
                    now = new Date();
                    for (_i = 0, broadcasts_1 = broadcasts; _i < broadcasts_1.length; _i++) {
                        item = broadcasts_1[_i];
                        if (!item.broadcast_date || !item.url)
                            continue;
                        broadcastDate = new Date(item.broadcast_date);
                        endWindow = new Date(broadcastDate.getTime() + 2 * 60 * 60 * 1000);
                        if (now >= broadcastDate && now <= endWindow) {
                            setIsLive(true);
                            setBroadcastUrl(item.url);
                            return [2 /*return*/];
                        }
                    }
                    setIsLive(false);
                    setBroadcastUrl(null);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error("API Hatası:", error_1);
                    setIsLive(false);
                    setBroadcastUrl(null);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchLiveBroadcast();
    }, []);
    // if isLive false return empty div
    if (!isLive) {
        return (_jsxs("div", __assign({ className: "homePromo" }, { children: [_jsxs("div", __assign({ className: "dropdown" }, { children: [_jsx("button", __assign({ className: "btn dropdown-toggle", "data-bs-toggle": "dropdown", "aria-expanded": "false" }, { children: "Bayilerimiz" })), _jsx("ul", __assign({ className: "dropdown-menu" }, { children: dealers.map(function (value, index) {
                                return (_jsx("li", __assign({ className: "mb-1" }, { children: _jsxs("a", __assign({ className: "dropdown-item", href: value.link, target: "_blank" }, { children: [_jsx("img", { className: "dealer-logo", src: value.logo, width: 60, height: 40, style: { objectFit: "contain" } }), _jsx("span", { children: value.label })] })) }), "dealer-".concat(index)));
                            }) }))] })), homePromoHtml != null ? _jsx("div", { dangerouslySetInnerHTML: sanitizedData() }) : _jsx(_Fragment, {})] })));
    }
    else {
        return (_jsx("div", __assign({ className: "homePromo" }, { children: _jsx("div", __assign({ className: "home-live-promo" }, { children: _jsx("iframe", { src: broadcastUrl
                        ? broadcastUrl.split("watch")[0] + "embed/" + ((_a = broadcastUrl.split("watch")[1]) === null || _a === void 0 ? void 0 : _a.replace("?v=", "")) + "?rel=0&autoplay=1"
                        : "", allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, width: "100%" }) })) })));
    }
}
function AppRouters() {
    var forceUpdate = useForceUpdate();
    useEffect(function () {
        var underServiceSubject_subscriber = underServiceSubject.subscribe(function (res) {
            if (res) {
                forceUpdate();
            }
        });
        return function () {
            underServiceSubject_subscriber.unsubscribe();
        };
    }, []);
    return (_jsx(_Fragment, { children: siteSettings["bakimModu"] && (siteSettings["bakimModu"] == "True" || siteSettings["bakimModu"] == "true") ? (_jsx(PageNotFound, {})) : (_jsxs(Router, { children: [_jsx(PageChangeHandler, {}), _jsx(Header, {}), _jsx(CartDropdown, {}), _jsxs("div", __assign({ id: "appContainer", className: "container-xl container-padding" }, { children: [_jsxs("div", __assign({ className: "row" }, { children: [_jsxs("div", __assign({ id: "id_homeHeader", className: "home-header" }, { children: [_jsx("div", __assign({ className: "home-main-slider" }, { children: _jsx(HomeSlider, {}) })), !isMobile && (_jsx("div", __assign({ className: "home-main-widget" }, { children: _jsx(HomePromoSlider, {}) })))] })), _jsx("div", __assign({ id: "mainWrapper", className: "main-wrapper col-lg-9" }, { children: _jsxs(Routes, { children: [_jsx(Route, { path: paths.login.url, element: _jsx(Login, {}) }), _jsx(Route, { path: paths.home.url, element: _jsx(Home, {}) }), _jsx(Route, { path: paths.redirectPage.url, element: _jsx(RedirectPage, {}) }), _jsx(Route, { path: paths.resetPassword.url, element: _jsx(Home, {}) }), _jsx(Route, { path: paths.verifyEmail.url, element: _jsx(Home, {}) }), _jsx(Route, { path: paths.register.url, element: _jsx(Register, { showBackButton: true }) }), _jsx(Route, { path: paths.registerMarket.url, element: _jsx(Register, { showBackButton: false }) }), _jsxs(Route, __assign({ path: paths.raffleTickets.url, element: _jsx(RaffleTickets, {}) }, { children: [_jsx(Route, { path: ":subpage", element: _jsx(RaffleTickets, {}) }), _jsx(Route, { path: ":draw_id/*", element: _jsx(RaffleTickets, {}) })] })), _jsx(Route, { path: paths.deposit.url, element: _jsx(Deposit, {}) }), _jsx(Route, { path: paths.withdraw.url, element: _jsx(ProtectedRoute, __assign({ nextPage: paths.withdraw.url }, { children: _jsx(Withdraw, {}) })) }), _jsx(Route, { path: paths.aboutus.url, element: _jsx(AboutUs, {}) }), _jsx(Route, { path: paths.transactions.url, element: _jsx(AccountTransactions, {}) }), _jsx(Route, { path: paths.campaign.url, element: _jsx(Campaigns, {}) }), _jsx(Route, { path: paths.liveStream.url, element: _jsx(LiveStream, {}) }), _jsx(Route, { path: paths.landing.url, element: _jsx(Landing, {}) }), _jsx(Route, { path: paths.giftTicket.url, element: _jsx(ProtectedRoute, __assign({ nextPage: paths.giftTicket.url }, { children: _jsx(GiftTicket, {}) })) }), _jsx(Route, __assign({ path: paths.games.url, element: _jsx(Games, {}) }, { children: _jsx(Route, { path: ":subpage", element: _jsx(Game, {}) }) })), _jsx(Route, __assign({ path: paths.products.url, element: _jsx(Products, {}) }, { children: _jsx(Route, { path: ":id", element: _jsx(Products, {}) }) })), _jsxs(Route, __assign({ path: paths.account.url, element: _jsx(ProtectedRoute, __assign({ nextPage: paths.account.url }, { children: _jsx(Account, {}) })) }, { children: [_jsx(Route, { path: ":page", element: _jsx(Account, {}) }), _jsx(Route, { path: ":page/:id/", element: _jsx(Account, {}) })] })), _jsxs(Route, __assign({ path: paths.support.url, element: _jsx(Support, {}) }, { children: [_jsx(Route, { path: ":page", element: _jsx(Support, {}) }), _jsx(Route, { path: ":page/:id/", element: _jsx(Support, {}) })] })), _jsx(Route, __assign({ path: paths.agreement.url, element: _jsx(Agreement, {}) }, { children: _jsx(Route, { path: ":slug", element: _jsx(Agreement, {}) }) })), _jsx(Route, __assign({ path: paths.notifications.url, element: _jsx(ProtectedRoute, __assign({ nextPage: paths.notifications.url }, { children: _jsx(Notifications, {}) })) }, { children: _jsx(Route, { path: ":notification_id", element: _jsx(Notifications, {}) }) })), _jsx(Route, { path: paths.cookieSettings.url, element: _jsx(CookieSettings, {}) }), _jsx(Route, { path: "*", element: _jsx(PageNotFound, {}) }), _jsx(Route, { path: paths.download.url, element: _jsx(QrCard, {}) }), _jsx(Route, { path: paths.reportLine.url, element: _jsx(ReportLine, {}) }), _jsxs(Route, __assign({ path: paths.scratch.url, element: _jsx(ScratchCards, {}) }, { children: [_jsx(Route, { path: ":subpage", element: _jsx(ScratchCards, {}) }), _jsx(Route, { path: ":subpage/:draw_id/*", element: _jsx(ScratchCards, {}) })] })), _jsx(Route, { path: paths.paparaCoupon.url, element: _jsx(PaparaCoupons, {}) }), _jsx(Route, { path: ".well-known/apple-app-site-association", element: _jsx(_Fragment, {}) })] }) })), _jsx("div", __assign({ id: "cartwidget" }, { children: _jsx(CartWidget, {}) }))] })), _jsxs("div", __assign({ id: "footerSection", className: "row ".concat(isMobile ? "py-2" : "pt-5 pb-2") }, { children: [_jsx("div", __assign({ className: "col-12 col-mobile-12" }, { children: _jsx(Footer, {}) })), !isMobile && (_jsx("div", __assign({ className: "col-3 col-mobile-12" }, { children: _jsx(AdultWarningText, {}) })))] })), !isMobile && (_jsxs("div", __assign({ className: "row mb-5 justify-content-center align-items-center footer-row", style: { marginTop: "-10px" } }, { children: [_jsx("div", __assign({ className: "col-6 fs-7", style: { color: "#A1B3B2" } }, { children: _jsxs("div", __assign({ className: "row" }, { children: [_jsx("div", __assign({ className: "col-3" }, { children: _jsx("img", { src: logo106, alt: "106 Dijital Logo", style: {
                                                        width: "90%",
                                                        marginTop: "-1rem",
                                                        marginLeft: "-1rem",
                                                        opacity: "0.5",
                                                    } }) })), _jsx("div", __assign({ className: "col-9 pt-4" }, { children: _jsx("p", __assign({ className: "align-middle" }, { children: "106 Dijital Hizmetler ve \u015Eans Oyunlar\u0131 Anonim \u015Eirketi Copyright \u00A9 2023" })) }))] })) })), _jsx("div", __assign({ className: "col-4 fs-7 text-align-end", style: { paddingTop: "10px" } }, { children: _jsxs("p", __assign({ style: { color: "#A1B3B2" } }, { children: [_jsx("span", __assign({ className: "p-1 rounded fs-6 text-white bg-danger me-2" }, { children: "+18" })), _jsx("span", __assign({ className: "p-1 text-black fw-bold" }, { children: "Milli Piyango'nun yasal bayisi olan Piyangosepeti'a 18 ya\u015F\u0131ndan b\u00FCy\u00FCkler \u00FCye olabilir." }))] })) })), _jsx("div", __assign({ className: "align-items-start col-2 d-flex justify-content-center" }, { children: _jsx("img", { style: { width: "94px" }, src: ssl }) }))] }))), !isMobile && _jsx("div", { style: { height: "2rem" } })] })), isMobile && _jsx(MobileFooter, {}), _jsx(UserMenu, {}), _jsx(DrawDetail, {}), _jsx(Advertisement, {})] })) }));
}
export function ProtectedRoute(props) {
    if (!auth.member) {
        return _jsx(Navigate, { to: "".concat(paths.login.url, "/?n=").concat(props.nextPage) });
    }
    return props.children;
}
export default AppRouters;
